import { useMutation, type MutationHookOptions } from "@apollo/client"
import tenantRemoveMutation from "@/v2-backoffice-client/tenant/remove/tenant.remove.mutation.gql"
import type {
  TenantRemoveMutation,
  TenantRemoveMutationVariables,
} from "@/v2-backoffice-client/tenant/remove/__types__/tenant.remove.mutation"

type RemoveOptions = MutationHookOptions<
  TenantRemoveMutation,
  TenantRemoveMutationVariables
>

export function useTenantRemoveMutation(options?: RemoveOptions) {
  return useMutation<TenantRemoveMutation, TenantRemoveMutationVariables>(
    tenantRemoveMutation,
    options,
  )
}
